import { Popover } from 'antd';
import { PopoverProps } from 'antd/lib/popover';

interface Props extends PopoverProps {}

export default function EnhancedPopover(props: Props) {
    return <Popover {...props} />;
}
